import React from 'react';
import { Star } from 'lucide-react';

// Renders a 1–5 star row; filled up to the (rounded) value.
const StarRating = ({ value = 0, size = 14 }) => {
  const rounded = Math.round(Number(value) || 0);
  return (
    <span className="review-stars" aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= rounded ? 'review-stars__icon review-stars__icon--on' : 'review-stars__icon'}
          fill={i <= rounded ? 'currentColor' : 'none'}
        />
      ))}
    </span>
  );
};

export default StarRating;
